<div *ngIf="showLoader" class="loader-wrapper">
  <mb-progress-bar></mb-progress-bar>
</div>
<mb-expandable-panel #expandablePanel>
  <div class="container-taxes" *ngIf="breakdown !== undefined">
    <div class="header-taxes">
      <button class="hidden-expan" (click)="toggle()">
        <mb-icon-text>
          <span>Ver menos <mb-icon icon="arrow-up"></mb-icon></span>
        </mb-icon-text>
      </button>
    </div>
    <div class="taxes bold" *ngIf="rate">
      <p class="name-taxes">
        <strong *ngIf="fop === 'PAY_AT_DESTINATION'">Valor en dólares</strong>
        <strong *ngIf="fop !== 'PAY_AT_DESTINATION'">{{ rate.key }}</strong>
      </p>
      <p class="value-taxes">
        <ng-container *ngIf="currencyCode === USD_CODE; else notUsd">
          <strong>{{ currencyLabel }} {{ rate.value | Currency }}</strong>
        </ng-container>
        <ng-template #notUsd>
          <strong>{{ fop === 'PAY_AT_DESTINATION' ? 'u$s' : '$' }}
            {{ rate.value | Currency }}</strong>
        </ng-template>
      </p>
    </div>
    <ul>
      <li *ngIf="fop === 'PAY_AT_DESTINATION'">
        <div class="taxes taxes--left-align">
          <p *ngIf="currencyCode !== USD_CODE" class="name-taxes">El precio en pesos argentinos es estimativo</p>
        </div>
      </li>
      <li *ngFor="let charge of charges">
        <div class="taxes">
          <p class="name-taxes">{{ charge.key }}</p>
          <p class="value-taxes">{{ currencyLabel }} {{ charge.value | Currency }}</p>
        </div>
      </li>
    </ul>
    <div class="disclaimer" *ngIf="information">
      <mb-icon icon="exclamation-circle" class="icon-focus"></mb-icon>
      <p class="disclaimer__text not-pad"><strong *ngIf="information?.title">{{ information?.title }}.</strong> {{ information?.information[0] }}</p>
    </div>
  </div>
</mb-expandable-panel>

